




















import { Vue, Component } from "vue-property-decorator";

import { UserModule } from "../store/modules/user";

import TitleBar from "../components/TitleBar.vue";
import CardComponent from "../components/CardComponent.vue";

@Component({
  name: "home",

  components: {
    CardComponent,
    TitleBar
  }
})
export default class Home extends Vue {
  get titleStack() {
    return ["Dashboard"];
  }

  mounted() {
  }

}
